export const ACTION_REQUIRED_MAIL_TYPE_IDS: readonly string[] = [
  'N-002',
  'N-005',
  'N-007',
  'N-008',
  'N-010',
  'N-011',
  'N-013',
  'N-014',
  'N-016',
  'N-017',
  'N-019',
  'N-021',
  'N-024',
  'N-027',
  'N-029',
] as const;
